<template>
  <div class="notice" :class="{'hasMoreBtn': !hasMore}">
    <!-- banner 部分 -->
    <div class="notice-banner">
      <div class="container">
        <div class="notice-banner-wrap">
          <!-- <img class="notice-logo" src="../assets/logo.png" alt=""> -->
          <p class="wemember-title">TGO 鲲鹏会公告与新闻</p>
          <p class="notice-slogan">构建全球化的有技术背景的优秀人才同侪学习成长平台</p>
        </div>
      </div>
    </div>

    <div class="notice-content container" ref="noticeContent">
      <!-- tab-bar 部分 -->
      <div class="notice-bar-wrap">
        <div class="notice-bar">
          <div class="select-item" :class="{'select-item_selected': curTypeId ===  Number(item.typeId)}" v-for="(item, index) in selectItems" @click="switchTab(item.typeId)" :key="index">{{item.name}}<span class="iconfont icon-jiantou" v-if="curTypeId ===  Number(item.typeId)"></span></div>
        </div>
      </div>

      <!-- 数据展示 -->
      <div class="notice-items">
        <notice-item v-for="(item, index) in noticeList" :key="index" :selected="curTypeId===Number(item.type)&&curId===Number(item.id)" :typeMap="typeMap" :item="item" :isLast="noticeList.length-1===index"></notice-item>
        <div class="tip-container">
          <tgoLoading v-if="loading" color="#D7B375" />
          <div class="wrapper" v-if="!loading&&!noticeList.length">
            <span class="iconfont icon-empty"></span>
            <span class="warn-tip">暂无公告与动态</span>
          </div>
        </div>
        <div class="getMore-container" v-if="!loading&&hasMore">
          <div @click="getNoticeList" class="get-more">
            加载更多
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import tgoLoading from '@/components/loading'
import noticeItem from './notice-item.vue'

import service from '@/service'
import cache from '@/util/cache-promise'

import data from '@/data'

export default {
  data () {
    return {
      curTypeId: 0,
      curId: 0,
      currentPage: 1, // 当前页码
      hasMore: false,
      params: {},
      typeMap: data.notice.typeMap, // tab 类型ID 内容映射
      selectItems: data.notice.selectItems, // tab 类型
      loading: false,
      noticeList: [],
      barFixed: false,
      noticeContentTop: 0 // 消息内容距离视口的高度
      // barHidden: false,
    }
  },
  components: {
    noticeItem,
    tgoLoading
  },
  created () {
    if (this.$route.query.type) this.curTypeId = Number(this.$route.query.type)
    if (this.$route.query.id) this.curId = Number(this.$route.query.id)

    // 获取数据
    this.getNoticeList()
  },
  mounted () {
    // 获取 notice-content 距离页面底部的高度
    const noticeContent = this.$refs.noticeContent
    this.noticeContentTop = noticeContent && noticeContent.offsetTop

    window.addEventListener('scroll', this.listenerScroll)

    // 滚动到 url 中指定的元素
    this.$nextTick(() => {
      // setTimeout(() => {
      const noticeItem = document.querySelector('.notice-item_selected')
      if (noticeItem) {
        // window.scrollTo(0, noticeItem.getBoundingClientRect().top - window.innerHeight / 3)
        noticeItem.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        })
      }
      // }, 500)
    })
  },
  methods: {
    switchTab (id) {
      this.$router.push({ query: { type: id } }, () => {})
      this.curTypeId = id
      this.initNoticeList()
      this.getNoticeList()
      if (this.barFixed) window.scrollTo(0, this.noticeContentTop)
    },
    initNoticeList () {
      this.currentPage = 1
      this.noticeList = []
    },
    getNoticeList () {
      if (this.loading) return

      this.loading = true

      let params = {
        type: this.curTypeId,
        page: this.currentPage,
        size: 10
      }
      // service.getNoticeList(params).then(data => {
      //   this.loading = false
      //   this.noticeList = this.noticeList.concat(data.list)
      //   this.currentPage = data.page.pages
      //   this.hasMore = data.page.more
      // }).catch(() => {
      //   this.loading = false
      // })

      // cache 测试
      cache.cache({
        fn: service.getNoticeList,
        parameter: params,
        maxAge: 30000
      })
        .then(data => {
          this.loading = false
          this.noticeList = this.noticeList.concat(data.list)
          this.hasMore = data.page.more
          if (data.page.more) this.currentPage = data.page.page + 1
        })
        .catch(err => {
          this.loading = false
          console.log(err && err.msg)
        })
    },
    listenerScroll () {
      const noticeContent = this.$refs.noticeContent
      // console.log(noticeContent)
      this.barFixed = noticeContent && noticeContent.getBoundingClientRect().top <= 0
      // this.barHidden = noticeContent && noticeContent.getBoundingClientRect().bottom < window.innerHeight
    }
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.listenerScroll)
  }
}
</script>
<style scoped lang='scss'>
@import '../../../style/bulma/app.sass';

.notice {
  margin-bottom: 50px;
  &.hasMoreBtn {
    margin-bottom: 105px;
  }
}
.notice-banner {
  height: 270px;
  background: url('../assets/banner.png') no-repeat center / cover;
  .container {
    position: relative;
    height: 100%;
    .notice-banner-wrap {
      max-width: 80vw;
      position: absolute;
      top: 50%;
      transform: translateY((-50%));
      // .notice-logo {
      //   width: 308px;
      //   margin-bottom: 10px;
      // }
      .wemember-title {
        font-size: 46px;
        font-family: PingFang SC;
        font-weight: 600;
        color: #fff;
      }
      .notice-slogan {
        font-size: 23px;
        color: #fff;
      }
    }
  }
}
.notice-content {
  display: flex;
  justify-content: flex-end;
  align-items: stretch;
  min-height: 500px;
}
.notice-bar {
  padding-top: 80px;
  width: 94px;
  margin-right: 74px;
  // margin-top: 20px;
  font-size: 17px;
  position: sticky;
  top: 20px;
  // left: 50%;
  // margin-left: -540px;
  // z-index: 10000;
  // &.notice-bar_fixed {
  //   position: sticky;
  //   top: 65px;
  //   // left: 50%;
  //   margin-left: -540px;
  //   z-index: 10000;
  // }
  .select-item {
    color: #4A4A4A;
    margin-bottom: 19px;
    position: relative;
    cursor: pointer;
    .iconfont {
      position: absolute;
      top: 0;
      right: 0;
      transform: translateY(-21%);
      font-size: 30px;
    }
    &.select-item_selected {
      color: $primary3;
    }
  }
}
.notice-items {
  padding-top: 60px;
  width: 912px;
  position: relative;
}

// 查看更多
.getMore-container {
  width: 100%;
  display: flex;
  justify-content: center;
  padding-top: 30px;
  .get-more {
    cursor: pointer;
    color: $primary3;
    font-size: 18px;
    padding: 8px 84px;
    border: 1px solid $primary3;
    border-radius: 5px;
  }
}

// 暂无活动
.tip-container {
  position: absolute;
  top: 43%;
  transform: translateY(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  .wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    .iconfont.icon-empty {
      font-size: 64px;
      color: rgba($primary3, 0.25);
    }
    .warn-tip {
      font-size: 18px;
      color: rgba(178, 178, 178, 1);
    }
  }
}
</style>
